import { Flex } from "@chakra-ui/react";
import { FC, useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useParams } from "react-router";

import {
  FrdClosureForm,
  FrdMeasurementConfigForm,
  FrdMeasurementForm,
  FrdStartRegistrationForm,
} from "@/features/frd";
import { EditGarForm, GarForm } from "@/features/gar";
import { GldAdditionForm, GldClosureForm, GldStartRegistrationForm } from "@/features/gld";
import {
  EditGmnMeasuringPointForm,
  GmnClosureForm,
  GmnMeasuringPointForm,
  GmnStartRegistrationForm,
} from "@/features/gmn";
import { GmwEventForm, GmwForm } from "@/features/gmw";
import { GpdAddReportForm, GpdEndRegistrationForm, GpdStartRegistrationForm } from "@/features/gpd";
import {
  GufAddRealisedInstallationForm,
  GufClosureForm,
  GufClosureRealisedPartForm,
  GufExpandedRealisedInstallationForm,
  GufHeightForm,
  GufNewLicenceForm,
  GufStartRegistrationForm,
  GufWellFunctionForm,
} from "@/features/guf/";
import { Header } from "@/features/header";
import { Overview } from "@/features/overview";

import {
  EditGarFormProps,
  FrdClosureFormProps,
  FrdMeasurementConfigFormProps,
  FrdMeasurementFormProps,
  FrdStartRegistrationFormProps,
  GldAdditionFormProps,
  GldClosureFormProps,
  GldStartRegistrationFormProps,
  GmnFormProps,
  GmnMeasuringPointFormProps,
  GmwEventFormProps,
  GmwFormProps,
  GpdAddReportFormProps,
  GpdEndRegistrationFormProps,
  GpdStartRegistrationFormProps,
  GufAddRealisedInstallationFormProps,
  GufClosureFormProps,
  GufClosureRealisedPartFormProps,
  GufExpandedRealisedInstallationFormProps,
  GufFormProps,
  GufHeightFormProps,
  GufNewLicenceFormProps,
  GufWellFunctionFormProps,
} from "../types/form-types";

import { Profile } from "./pages/profile";
import { SendObjectToForm } from "./send-object-to-form/components/send-object-to-form";

export const routes = [
  {
    path: "/",
    page: <Overview />,
  },
  {
    path: "/profile/",
    page: <Profile />,
  },
  {
    path: "/gmn/startregistratie/",
    page: <GmnStartRegistrationForm />,
  },
  {
    path: "/gmn/startregistratie/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GmnFormProps) => <GmnStartRegistrationForm {...props} />}
      />
    ),
  },
  {
    path: "/gmn/startregistratie/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gmn"
        renderFunction={(props: GmnFormProps) => <GmnStartRegistrationForm {...props} />}
      />
    ),
  },
  {
    path: "/gmn/meetpunt/",
    page: <GmnMeasuringPointForm />,
  },
  // {
  //   path: "/gmn/meetpunt/uploadTask/:uuid",
  //   page: (params: Record<string, string | undefined>) => (
  //     <SendObjectToForm
  //       uuid={params.uuid}
  //       type="uploadTask"
  //       renderFunction={(props: GmnFormProps) => <GmnMeasuringPointForm {...props} />}
  //     />
  //   ),
  // },
  {
    path: "/gmn/meetpunt/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gmnMeasuringPoint"
        renderFunction={(props: GmnMeasuringPointFormProps) => (
          <EditGmnMeasuringPointForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/gmn/beeindigen/",
    page: <GmnClosureForm />,
  },
  {
    path: "/gmn/beeindigen/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GmnFormProps) => <GmnClosureForm {...props} />}
      />
    ),
  },
  {
    path: "/gmn/beeindigen/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gmn"
        renderFunction={(props: GmnFormProps) => <GmnClosureForm {...props} />}
      />
    ),
  },
  {
    path: "/gmw/constructie/",
    page: <GmwForm />,
  },
  {
    path: "/gmw/constructie/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GmwFormProps) => <GmwForm {...props} />}
      />
    ),
  },
  {
    path: "/gmw/constructie/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gmw"
        renderFunction={(props: GmwFormProps) => <GmwForm {...props} />}
      />
    ),
  },
  {
    path: "/gmw/gebeurtenissen/",
    page: <GmwEventForm />,
  },
  {
    path: "/gmw/gebeurtenissen/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GmwEventFormProps) => <GmwEventForm {...props} />}
      />
    ),
  },
  {
    path: "/gmw/gebeurtenissen/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gmwEvent"
        renderFunction={(props: GmwEventFormProps) => <GmwEventForm {...props} />}
      />
    ),
  },
  {
    path: "/gar/",
    page: <GarForm />,
  },
  {
    path: "/gar/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gar"
        renderFunction={(props: EditGarFormProps) => <EditGarForm {...props} />}
      />
    ),
  },
  {
    path: "/gar/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: EditGarFormProps) => <EditGarForm {...props} />}
      />
    ),
  },

  {
    path: "/gld/startregistratie/",
    page: <GldStartRegistrationForm />,
  },
  {
    path: "/gld/startregistratie/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GldStartRegistrationFormProps) => (
          <GldStartRegistrationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/gld/startregistratie/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gld"
        renderFunction={(props: GldStartRegistrationFormProps) => (
          <GldStartRegistrationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/gld/aanvulling/",
    page: <GldAdditionForm />,
  },
  {
    path: "/gld/aanvulling/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GldAdditionFormProps) => <GldAdditionForm {...props} />}
      />
    ),
  },
  {
    path: "/gld/aanvulling/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gldAddition"
        renderFunction={(props: GldAdditionFormProps) => <GldAdditionForm {...props} />}
      />
    ),
  },
  {
    path: "/gld/beeindigen/",
    page: <GldClosureForm />,
  },
  {
    path: "/gld/beeindigen/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GldClosureFormProps) => <GldClosureForm {...props} />}
      />
    ),
  },
  {
    path: "/gld/beeindigen/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gld"
        renderFunction={(props: GldClosureFormProps) => <GldClosureForm {...props} />}
      />
    ),
  },

  {
    path: "/gpd/startregistratie/",
    page: <GpdStartRegistrationForm />,
  },
  {
    path: "/gpd/startregistratie/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GpdStartRegistrationFormProps) => (
          <GpdStartRegistrationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/gpd/startregistratie/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gpd"
        renderFunction={(props: GpdStartRegistrationFormProps) => (
          <GpdStartRegistrationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/gpd/rapport/",
    page: <GpdAddReportForm />,
  },
  {
    path: "/gpd/rapport/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GpdAddReportFormProps) => <GpdAddReportForm {...props} />}
      />
    ),
  },
  {
    path: "/gpd/rapport/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gpdReport"
        renderFunction={(props: GpdAddReportFormProps) => <GpdAddReportForm {...props} />}
      />
    ),
  },
  {
    path: "/gpd/beeindigen/",
    page: <GpdEndRegistrationForm />,
  },
  {
    path: "/gpd/beeindigen/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GpdEndRegistrationFormProps) => (
          <GpdEndRegistrationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/gpd/beeindigen/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gpdEnd"
        renderFunction={(props: GpdEndRegistrationFormProps) => (
          <GpdEndRegistrationForm {...props} />
        )}
      />
    ),
  },

  {
    path: "/frd/startregistratie/",
    page: <FrdStartRegistrationForm />,
  },
  {
    path: "/frd/startregistratie/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: FrdStartRegistrationFormProps) => (
          <FrdStartRegistrationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/frd/startregistratie/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="frd"
        renderFunction={(props: FrdStartRegistrationFormProps) => (
          <FrdStartRegistrationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/frd/meetconfiguratie/",
    page: <FrdMeasurementConfigForm />,
  },
  {
    path: "/frd/meetconfiguratie/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: FrdMeasurementConfigFormProps) => (
          <FrdMeasurementConfigForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/frd/meetconfiguratie/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="frd"
        renderFunction={(props: FrdMeasurementConfigFormProps) => (
          <FrdMeasurementConfigForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/frd/meting/",
    page: <FrdMeasurementForm />,
  },
  {
    path: "/frd/meting/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: FrdMeasurementFormProps) => <FrdMeasurementForm {...props} />}
      />
    ),
  },
  {
    path: "/frd/meting/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="frd"
        renderFunction={(props: FrdMeasurementFormProps) => <FrdMeasurementForm {...props} />}
      />
    ),
  },
  {
    path: "/frd/beeindigen/",
    page: <FrdClosureForm />,
  },
  {
    path: "/frd/beeindigen/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: FrdClosureFormProps) => <FrdClosureForm {...props} />}
      />
    ),
  },
  {
    path: "/frd/beeindigen/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="frd"
        renderFunction={(props: FrdClosureFormProps) => <FrdClosureForm {...props} />}
      />
    ),
  },
  // GUF routes
  {
    path: "/guf/startregistratie/",
    page: <GufStartRegistrationForm />,
  },
  {
    path: "/guf/startregistratie/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GufFormProps) => <GufStartRegistrationForm {...props} />}
      />
    ),
  },
  {
    path: "/guf/startregistratie/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="guf"
        renderFunction={(props: GufFormProps) => <GufStartRegistrationForm {...props} />}
      />
    ),
  },
  // GUF NewLicence
  {
    path: "/guf/nieuwe-vergunning/",
    page: <GufNewLicenceForm />,
  },
  {
    path: "/guf/nieuwe-vergunning/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GufNewLicenceFormProps) => <GufNewLicenceForm {...props} />}
      />
    ),
  },
  {
    path: "/guf/nieuwe-vergunning/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gufEvent"
        renderFunction={(props: GufNewLicenceFormProps) => <GufNewLicenceForm {...props} />}
      />
    ),
  },
  // GUF AddRealisedInstallation
  {
    path: "/guf/gerealiseerde-installatie-toevoegen/",
    page: <GufAddRealisedInstallationForm />,
  },
  {
    path: "/guf/gerealiseerde-installatie-toevoegen/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GufAddRealisedInstallationFormProps) => (
          <GufAddRealisedInstallationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/guf/gerealiseerde-installatie-toevoegen/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gufEvent"
        renderFunction={(props: GufAddRealisedInstallationFormProps) => (
          <GufAddRealisedInstallationForm {...props} />
        )}
      />
    ),
  },
  // GUF ExpandedRealisedInstallation
  {
    path: "/guf/gerealiseerde-installatie-uitbreiden/",
    page: <GufExpandedRealisedInstallationForm />,
  },
  {
    path: "/guf/gerealiseerde-installatie-uitbreiden/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GufExpandedRealisedInstallationFormProps) => (
          <GufExpandedRealisedInstallationForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/guf/gerealiseerde-installatie-uitbreiden/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gufEvent"
        renderFunction={(props: GufExpandedRealisedInstallationFormProps) => (
          <GufExpandedRealisedInstallationForm {...props} />
        )}
      />
    ),
  },
  // GUF Height
  {
    path: "/guf/hoogte/",
    page: <GufHeightForm />,
  },
  {
    path: "/guf/hoogte/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GufHeightFormProps) => <GufHeightForm {...props} />}
      />
    ),
  },
  {
    path: "/guf/hoogte/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gufEvent"
        renderFunction={(props: GufHeightFormProps) => <GufHeightForm {...props} />}
      />
    ),
  },
  // GUF WellFunction
  {
    path: "/guf/putfunctie/",
    page: <GufWellFunctionForm />,
  },
  {
    path: "/guf/putfunctie/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GufWellFunctionFormProps) => <GufWellFunctionForm {...props} />}
      />
    ),
  },
  {
    path: "/guf/putfunctie/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gufEvent"
        renderFunction={(props: GufWellFunctionFormProps) => <GufWellFunctionForm {...props} />}
      />
    ),
  },
  // GUF ClosureRealisedPart
  {
    path: "/guf/gerealiseerd-deel-beeindigen/",
    page: <GufClosureRealisedPartForm />,
  },
  {
    path: "/guf/gerealiseerd-deel-beeindigen/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GufClosureRealisedPartFormProps) => (
          <GufClosureRealisedPartForm {...props} />
        )}
      />
    ),
  },
  {
    path: "/guf/gerealiseerd-deel-beeindigen/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gufEvent"
        renderFunction={(props: GufClosureRealisedPartFormProps) => (
          <GufClosureRealisedPartForm {...props} />
        )}
      />
    ),
  },
  // GUF Closure
  {
    path: "/guf/beeindigen/",
    page: <GufClosureForm />,
  },
  {
    path: "/guf/beeindigen/uploadTask/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="uploadTask"
        renderFunction={(props: GufClosureFormProps) => <GufClosureForm {...props} />}
      />
    ),
  },
  {
    path: "/guf/beeindigen/:uuid",
    page: (params: Record<string, string | undefined>) => (
      <SendObjectToForm
        uuid={params.uuid}
        type="gufEvent"
        renderFunction={(props: GufClosureFormProps) => <GufClosureForm {...props} />}
      />
    ),
  },
];

type PageProp = React.ReactNode | ((params: Record<string, string | undefined>) => React.ReactNode);

const RouteElement: FC<{ page: PageProp }> = ({ page }) => {
  const params = useParams();
  // FUTURE. Check this
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{typeof page === "function" ? page(params) : page}</>;
};

const AppRoutes: FC = () => {
  const location = useLocation();
  const isPublicPage = location.pathname.startsWith("/public/");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Flex p={!isPublicPage ? "5" : "0"} h={!isPublicPage ? "100vh" : "auto"} flexDir="column">
      {!isPublicPage && <Header />}
      <Routes>
        {routes.map(({ path, page }) => (
          <Route key={path} path={path} element={<RouteElement page={page} />} />
        ))}
        <Route path="/public/*" element={null} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Flex>
  );
};

export { AppRoutes };
